import variables from "./variables";
import people from "./people/people";

class Thing {
    constructor(key="", name="", price=0, description="", type="thing") {
        this.key = key;
        this.name = name;
        this.price = price;
        this.description = description;
        this.type = type;
        this.bought = variables.player.things[this.key] ? variables.player.things[this.key] : false;
    }

    buy() {
        if (people.player.money - this.price < 0)
            return false
        people.player.set("money", people.player.money - this.price)
        this.bought = true;
        variables.player.things.addNew(this.name, true);

        return true;
    }
}

class Pill extends Thing{
    constructor(key="", name="", price=0, description="") {
        super(key, name, price, description, "pill");
        this.treated = variables.wife.pillsTreated[this.key] ? variables.wife.pillsTreated[this.key] : false;
    }

    treat() {
        this.treated = true;
        variables.wife.pillsTreated.addNew(this.key, true);
    }
}

const things = {
    pinaBottle: new Thing("pinaBottle", "Piña Colada", 50, "Piña Colada Bottle"),

    pillForJob: new Pill("pillForJob", "Job Pill", 0,
        "Pill that helps people overcome internal psychological difficulties (Fear of evaluation / Fear of the unknown / Fear of being rejected)")
};

export default things;